import { call, put } from "redux-saga/effects";
import { api } from "../../../services";
import { Creators } from "./index";

import { Alerts } from "../../../lib";

export default function* refuseAccessAmcred({ data, callback }) {
  try {
    const response = yield call(api.postRefuseAccessAmcred, data);

    yield put(Creators.refuseAccessAmcredSuccess(response?.data));
    callback();
  } catch (response) {
    Alerts.alertError(
      response?.data?.log
        ? response?.data?.log
        : "Não foi possível encontrar as solicitações de acesso"
    );

    yield put(Creators.refuseAccessAmcredFailure());
  }
}
